/**
 * main.js — Wallop Motion Entry Point
 *
 * Single entry point bundled by Vite into dist/wallop-motion.js.
 * CSS is imported here so Vite extracts it to dist/wallop-motion.css.
 *
 * Reveals, parallax, image reveals, and page transitions are pure CSS
 * (scroll-driven animations + the View Transitions API). The only job
 * left for JavaScript is owning the Lenis instance and its lifecycle.
 */

import "./scroll-reveal.css";
import "./parallax.css";
import "./transitions.css";
import { initLenis, initLenisLifecycle } from "./lenis.js";

document.addEventListener("DOMContentLoaded", () => {
  initLenis();
  initLenisLifecycle();
});
